export default __webpack_public_path__ + "static/media/loading.1b910ae0.svg";